module.exports = ".datatable-footer {\n  border: none !important;\n  padding: 0px !important;\n  height: auto !important;\n}"